import React from 'react'
import SectionSeparator from '../../pb_section_separator/_section_separator'

const SectionSeparatorDashed = (props) => {
    return (
        <SectionSeparator
            {...props}
            lineStyle='dashed'
        />
    )
}

export default SectionSeparatorDashed
